import { render, staticRenderFns } from "./CurriculumRead.vue?vue&type=template&id=2efc72dd&scoped=true&"
import script from "./CurriculumRead.vue?vue&type=script&lang=ts&"
export * from "./CurriculumRead.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumRead.vue?vue&type=style&index=0&id=2efc72dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efc72dd",
  null
  
)

export default component.exports